var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":require("../assets/erweima.jpg")}}),_c('div',{staticStyle:{"text-align":"right"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$emit('chanePage')}}},[_vm._v("关闭")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }